import { PRODUCT_PRICE_CURRENCY_CODE } from 'appConstants/product';
import { formatPriceValue } from 'utils';

import type { IEnvCropsFailedOrdersState } from './types';

export const selectFailedOrders = (state: IEnvCropsFailedOrdersState) =>
  state.failedOrders.map((failedOrder) => {
    return {
      ...failedOrder,
      products: failedOrder.products.map((product) => {
        const quantityUnit = product.uomMemonic || product.uomMnemonic;

        return {
          ...product,
          quantityLabel: quantityUnit
            ? `${product.quantity} ${quantityUnit}`
            : `${product.quantity}`,
          location: failedOrder.locationShortName,
          totalPrice: formatPriceValue(
            product.quantity * product.packs * product.unitPrice,
            PRODUCT_PRICE_CURRENCY_CODE,
          ),
        };
      }),
    };
  });
